import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ob-kotlov',
  templateUrl: './ob-kotlov.component.html',
  styleUrls: ['./ob-kotlov.component.scss']
})
export class ObKotlovComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
